import { Slideover } from "@/components/Base/Headless";
// import { Menu } from "@/components/Base/Headless";
import Lucide from "@/components/Base/Lucide";
// import activities from "@/fakers/activities"; // Disabled faker data
// import FileIcon from "@/components/Base/FileIcon";
// import _ from "lodash";
// import clsx from "clsx";

interface MainProps {
  activitiesPanel: boolean;
  setActivitiesPanel: (val: boolean) => void;
}

function Main(props: MainProps) {
  return (
    <div>
      <Slideover
        open={props.activitiesPanel}
        onClose={() => {
          props.setActivitiesPanel(false);
        }}
      >
        <Slideover.Panel className="w-72 rounded-[0.75rem_0_0_0.75rem/1.1rem_0_0_1.1rem]">
          <a
            href=""
            className="focus:outline-none hover:bg-white/10 bg-white/5 transition-all hover:rotate-180 absolute inset-y-0 left-0 right-auto flex items-center justify-center my-auto -ml-[60px] sm:-ml-[105px] border rounded-full text-white/90 w-8 h-8 sm:w-14 sm:h-14 border-white/90 hover:scale-105 dark:bg-darkmode-800/40 dark:border-darkmode-800/20"
            onClick={(e) => {
              e.preventDefault();
              props.setActivitiesPanel(false);
            }}
          >
            <Lucide className="w-8 h-8 stroke-[1]" icon="X" />
          </a>
          <Slideover.Title className="px-6 py-5">
            <h2 className="mr-auto text-base font-medium">Latest Activities</h2>
          </Slideover.Title>
          <Slideover.Description className="p-0">
            <div className="flex flex-col items-center justify-center p-8 min-h-[200px]">
              <div className="text-center text-slate-500 dark:text-slate-400">
                <Lucide icon="LayoutGrid" className="w-12 h-12 mx-auto mb-3 opacity-50" />
                <p className="text-sm">No activities</p>
              </div>
            </div>
          </Slideover.Description>
        </Slideover.Panel>
      </Slideover>
    </div>
  );
}

export default Main;
